import Badge from '../common/Badge';
import { fmt } from '../../utils/formatters';
import { FILLER_PRODUCTS } from '../../constants';

export default function DailyLimitPanel({ dailyLimit, todaySalesExcludingSelf, grandTotal, onAddFiller }) {
  const min = dailyLimit?.min ?? dailyLimit ?? 0;
  const max = dailyLimit?.max;
  const rangeLabel = max ? `${fmt(min)}–${fmt(max)}` : fmt(min);

  const withToday = todaySalesExcludingSelf + grandTotal;
  const limitGap = min - withToday;
  const needsFill = limitGap > 0.5;

  return (
    <div className={`limit-panel ${needsFill ? 'warn' : 'ok'}`} style={{ margin: '0 32px 20px' }}>
      <div className="limit-header">
        <div>
          <div className="limit-title">
            {needsFill
              ? `⚠ £${limitGap.toFixed(2)} below daily limit (${rangeLabel})`
              : `✓ Daily limit of ${rangeLabel} will be met`}
          </div>
          <div className="limit-sub">
            Other invoices today: {fmt(todaySalesExcludingSelf)} + this: {fmt(grandTotal)} = {fmt(withToday)}
          </div>
        </div>
        <Badge variant={needsFill ? 'warning' : 'success'}>
          {needsFill ? `Gap: ${fmt(limitGap)}` : 'Limit Met'}
        </Badge>
      </div>

      {needsFill && (
        <>
          <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 7, color: 'var(--warning)' }}>
            Quick-add products (server will also auto-add on save):
          </div>
          <div className="filler-grid">
            {FILLER_PRODUCTS.slice(0, 10).map(p => (
              <button
                key={p.name}
                className="filler-chip"
                onClick={() => {
                  const qty = Math.max(1, Math.ceil(limitGap / (p.vatRate === 20 ? p.unitPrice * 1.2 : p.unitPrice)));
                  onAddFiller(p, qty);
                }}
              >
                {p.name} — {fmt(p.unitPrice)}{p.vatRate ? ' +VAT' : ''}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
